<template>
    <v-dialog v-model="dialogPEFC" max-width="1250px" persistent @keydown.esc="chiudidialogPEFC">
        <v-container style="background-color: white;" fluid>
            <v-row class="ma-0 pa-0" align="center">
                <v-btn icon @click="caricaDati">
                    <v-icon>refresh</v-icon>
                </v-btn>
                <v-btn color="success" @click="apriDialogItem()" small class="mt-1 ml-2">
                    <v-icon left>add</v-icon> Aggiungi gruppo di prodotto
                </v-btn>
                <v-btn small class="mt-1 ml-3" @click="resetValori()">
                    Ripristina valori predefiniti
                </v-btn>

                <!-- Pulsante elimina in blocco: visibile solo se ci sono selezioni -->
                <v-btn v-if="selectedItems.length > 0" color="error" small class="mt-1 ml-3"
                    @click="eliminaSelezionati">
                    <v-icon left>delete_sweep</v-icon>
                    Elimina selezionati ({{ selectedItems.length }})
                </v-btn>

                <v-spacer />
                <v-btn icon @click="chiudidialogPEFC">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-row>

            <v-text-field v-model="search" append-icon="search" label="Cerca..." class="mt-2 mb-2" solo clearable />

            <v-data-table v-model="selectedItems" :headers="headers" :items="items" :search="search" class="elevation-1"
                hide-default-footer :items-per-page="-1" fixed-header height="60vh" dense
                no-data-text="Nessun dato disponibile" show-select item-key="idGruppo">
                <template v-slot:item.actions="{ item }" class="pa-0 ma-0">
                    <v-row class="ma-0 pa-0">
                        <v-btn icon color="primary" @click="apriDialogItem(item)">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn icon color="primary" @click="duplicaElemento(item)">
                            <v-icon>content_copy</v-icon>
                        </v-btn>
                        <v-btn icon color="error" @click="eliminaElemento(item)">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </v-row>
                </template>
            </v-data-table>

            <!-- Dialog modifica/aggiungi (invariato) -->
            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ editedItem.idGruppo != "-1" ? 'Modifica' : 'Aggiungi' }} gruppo di
                            prodotto</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form">
                            <v-text-field v-model="editedItem.codGruppo" label="Codice Gruppo" required />
                            <v-text-field v-model="editedItem.descrizione" label="Descrizione" required />
                            <v-text-field v-model="editedItem.traduzione" label="Traduzione" required />
                            <v-select v-model="editedItem.inputOutput" label="Input/Output" :items="['I', 'O', 'E']"
                                required />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn @click="chiudiDialogItem">Annulla</v-btn>
                        <v-btn color="primary" @click="salvaElemento">Salva</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-dialog>
</template>

<script>
import {
    get_gruppi_prodotto, post_gruppo_prodotto, del_gruppo_prodotto, del_gruppi_prodotto_bulk, reset_gruppi_prodotto
} from '@/api/api.registroSintesiPEFC.js'

export default {
    props: {
        dialogPEFC: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
    },

    data() {
        return {
            dialog: false,
            search: '',
            items: [],
            selectedItems: [],   // <-- righe selezionate
            editedItem: {
                idGruppo: null,
                codGruppo: '',
                descrizione: '',
                traduzione: '',
                inputOutput: 'I',
            },
            headers: [
                { text: 'ID', value: 'idGruppo' },
                { text: 'Codice', value: 'codGruppo' },
                { text: 'Descrizione', value: 'descrizione' },
                { text: 'Traduzione', value: 'traduzione' },
                { text: 'Tipologia', value: 'inputOutput' },
                { text: 'Azioni', value: 'actions', sortable: false }
            ]
        }
    },

    methods: {
        async caricaDati() {
            let par = ""
            if (this.role !== "utente")
                par = "?companyCode=" + this.compCode;
            let res = await get_gruppi_prodotto(par);
            this.items = res.data;
            this.selectedItems = [];  // reset selezione dopo ricarica
        },

        apriDialogItem(item = null) {
            this.editedItem = item
                ? { ...item }
                : { companyCode: this.compCode, idGruppo: -1, codGruppo: '', descrizione: '', traduzione: '', inputOutput: 'I' }
            this.dialog = true
        },

        duplicaElemento(item) {
            this.editedItem = { ...item };
            this.editedItem.idGruppo = -1;
            this.editedItem.codGruppo = "";
            this.dialog = true;
        },

        chiudiDialogItem() {
            this.dialog = false
        },

        async salvaElemento() {
            if (!this.editedItem.descrizione || !this.editedItem.codGruppo || !this.editedItem.traduzione || !this.editedItem.inputOutput) return;
            let res = await post_gruppo_prodotto(this.editedItem)
            if (res.data === "OK") {
                this.caricaDati()
                this.dialog = false
            } else {
                this.$toast.error("Errore. " + res.data)
            }
        },

        chiudidialogPEFC() {
            this.$emit('close')
        },

        async eliminaElemento(item) {
            let confirm = await this.$confirm.open("Elimina", "Eliminare il gruppo <b>" + item.descrizione + "</b>?");
            if (!confirm) return;
            let res = await del_gruppo_prodotto(item);
            if (res.data === "OK") this.caricaDati();
        },

        async resetValori() {
            let confirm = await this.$confirm.open("Reset", "Ripristinare i gruppi di prodotto di questo cliente ai valori predefiniti?");
            if (!confirm) return;
            let par = "?companyCode=" + this.compCode;
            let res = await reset_gruppi_prodotto(par);
            if (res.data == "OK") this.caricaDati();
            else this.$toast.alert(res.data);
        },

        async eliminaSelezionati() {
            const nomi = this.selectedItems.map(i => i.descrizione).join(', ');
            let confirm = await this.$confirm.open(
                "Elimina selezionati",
                `Eliminare i <b>${this.selectedItems.length}</b> gruppi selezionati?<br><small>${nomi}</small>`
            );
            if (!confirm) return;
            let res = await del_gruppi_prodotto_bulk(this.selectedItems);
            if (res.data === "OK") {
                this.caricaDati();
            } else {
                this.$toast.error("Errore. " + res.data);
            }
        },
    },

    watch: {
        dialogPEFC(newVal) {
            if (newVal) this.caricaDati();
        }
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },
    },
}
</script>